import { render, staticRenderFns } from "./AppendixRenewalSimDetail.vue?vue&type=template&id=12fc5e7c"
import script from "./AppendixRenewalSimDetail.vue?vue&type=script&lang=js"
export * from "./AppendixRenewalSimDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports